import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";
import { ConsultationExportStatus } from "shared";

export const startConsultationExport = async (quoteId: string): Promise<{ exportId: string }> => {
  const response = await api.export.exportConsultation.mutation({
    params: { id: quoteId },
    body: {},
  });

  if (response.status === 202) {
    return response.body;
  }

  throw new ApiError("Failed to start the consultation export", response.status, response.body);
};

export const fetchConsultationExport = async ({
  quoteId,
  exportId,
}: {
  quoteId: string;
  exportId: string;
}): Promise<ConsultationExportStatus> => {
  const response = await api.export.getConsultationExport.query({
    params: { id: quoteId, exportId },
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to fetch the consultation export", response.status, response.body);
};
